import React from "react";

const InputField = ({
  id,
  mainClass,
  label,
  type,
  name,
  className,
  placeholder,
  customClass,
  value,
  onChange,
  onBlur,
  error,
  touch,
  min, // Add min as an optional prop
}) => {
  return (
    <div className={`${mainClass}`}>
      <label
        htmlFor={id}
        className={`block mt-2 text-sm font-medium text-gray-900 ${customClass}`}
      >
        {label}
      </label>
      <div>
        <input
          type={type}
          name={name}
          id={id}
          className={`bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 ${className}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          min={min} // Pass the min prop to the input element
        />
        {error && touch ? (
          <h1 className="text-xs text-red-600">{error}</h1>
        ) : null}
      </div>
    </div>
  );
};

export default InputField;
